<template>
  <v-dialog :isActive="open" v-model="open" width="500" class="modal" data-app>
    <div id="popup">
      <div class="header">
        <span
          v-html="$t('image_right.popup.message', { email: email, name: name })"
        ></span>
        <!-- <span v-html="$t('image_right.popup.copy_link')"></span>
        <span
          @click="copyLink"
          v-html="$t('image_right.click_here')"
          style="font-weight: bold; cursor: pointer"
        ></span> -->
      </div>
      <div class="buttons">
        <button v-on:click="cancel()" class="btn">
          {{ $t("image_right.popup.buttons.no_send") }}
        </button>
        <button v-on:click="send()" class="btn main">
          {{ $t("image_right.popup.buttons.send") }}
        </button>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import i18n from "@/i18n";

export default {
  name: "ImageRightPopup",
  props: ["dialog", "type", "email", "name", "link"],
  data() {
    return {
      open: false,
      //   email: "",
      //   name: "",
    };
  },
  methods: {
    cancel() {
      // close dialog
      this.open = false;
      this.$emit("close");
    },

    send() {
      this.open = false;
      this.$emit("send");
    },

    copyLink() {
      navigator.clipboard.writeText(this.link);
      this.$emit("copy");
    },
  },
  watch: {
    dialog: function () {
      this.open = this.dialog;
    },
    open: function () {
      if (!this.open) {
        this.$emit("close");
      }
    },
    // email_contact: function (val) {
    //   alert(val);
    //   this.email = val;
    // },
    // name_person: function (val) {
    //   this.name = val;
    // },
  },
};
</script>

<style lang="scss" scoped>
#popup {
  min-height: 150px;
  background-color: white;
  padding: 10px 0;
  .header {
    padding: 10px;
    span {
      text-align: center;
      color: #222;
      font-size: 16px;
    }
    img {
      display: block;
      text-align: center;
      margin: 0 auto;
      padding-top: 10px;
      width: 50px;
      height: 50px;
    }
  }

  .buttons {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    .btn {
      margin: 0 auto;
      text-align: center;
      display: block;
      min-width: 40px;
      padding: 0 35px;
      outline: none;
      cursor: pointer;
      font-size: 16px;
      border-radius: 3px;
      -webkit-transition: all 0.5s;
      transition: all 0.5s;
      color: #c55c00;
      min-height: 40px;
      line-height: 40px;
      text-transform: uppercase;
      background-color: transparent;
      font-family: AvantGarde-Bold;
      max-width: 300px;
      transition: background-color 0.5s ease;
      border: 1px solid #fc8926;
      margin: 0 10px;

      &:hover {
        background-color: #fc8a2623 !important;
      }
      &.main {
        background-color: #fc8926;
        color: #fff;
      }
    }
  }
}

@include media("<=desktop") {
  #popup {
    .buttons {
      .btn {
        line-height: 20px;
      }
    }
  }
}
</style>
